import { ArrowLeft } from "lucide-react";
import { useForm } from "react-hook-form";
import { usePackagesStore } from "../store/packagesStore";
import Swal from "sweetalert2";
import { useState } from "react";
import { ScaleLoader } from "react-spinners";

interface CreatePackageFormProps {
    onClose: () => void;
}

interface PackageFormData {
    name: string;
    description: string;
    price: number;
    duration: number;
    service_name: string;
    // content: string;
}

export default function CreatePackageForm({ onClose }: CreatePackageFormProps) {
    const { register, handleSubmit, reset } = useForm<PackageFormData>();
    const { createPackage } = usePackagesStore();
    const [loading, setLoading] = useState(false);

    const onSubmit = async (data: PackageFormData) => {
        try {
            setLoading(true);
            const result: any = await createPackage(data);
            setLoading(false);
            Swal.fire({
                icon: "success",
                title: "Package Created",
                text: `Package "${result.message.name}" was created successfully.`,
                confirmButtonColor: "#3085d6",
            });

            onClose();
            reset();
        } catch (error: any) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.message || "Failed to create package.",
                confirmButtonColor: "#d33",
            });
            console.error("Failed to create package:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full flex flex-col items-start justify-start mt-14">
            <div className="flex items-center gap-x-1 text-xs text-white cursor-pointer hover:text-gray-300" onClick={onClose}>
                <ArrowLeft size={12} />
                Back
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="w-full flex flex-col gap-4 my-4">
                <div className="flex gap-x-2 items-start justify-between">
                    <div className="w-1/2">
                        <p className="text-white text-xs">Package Name</p>
                        <input
                            {...register("name", { required: true })}
                            type="text"
                            placeholder="Package Name"
                            className="w-full bg-white rounded-md p-2 text-black text-xs"
                        />
                    </div>
                    <div className="w-1/2">
                        <p className="text-white text-xs">Description</p>
                        <textarea
                            {...register("description", { required: true })}
                            rows={3}
                            cols={20}
                            placeholder="Description"
                            className="w-full bg-white rounded-md p-2 text-black text-xs"
                        />
                    </div>
                </div>

                <div className="flex gap-x-2 items-start justify-between">
                    <div className="w-1/2">
                        <p className="text-white text-xs">Package Price</p>
                        <input
                            {...register("price", { required: true })}
                            type="number"
                            placeholder="Package Price"
                            className="w-full bg-white rounded-md p-2 text-black text-xs"
                        />
                    </div>
                    <div className="w-1/2">
                        <p className="text-white text-xs">Duration</p>
                        <input
                            {...register("duration", { required: true })}
                            type="number"
                            placeholder="Duration"
                            className="w-full bg-white rounded-md p-2 text-black text-xs"
                        />
                    </div>
                </div>

                <div className="flex gap-x-2 items-start justify-between">
                    <div className="w-1/2">
                        <p className="text-white text-xs">Service</p>
                        <input
                            {...register("service_name", { required: true })}
                            type="text"
                            placeholder="Service"
                            className="w-full bg-white rounded-md p-2 text-black text-xs"
                        />
                    </div>
                    {/* <div className="w-1/2">
                        <p className="text-white text-xs">Content</p>
                        <input 
                            {...register("content", { required: true })}
                            type="text" 
                            placeholder="Content" 
                            className="w-full bg-white rounded-md p-2 text-black text-xs" 
                        />
                    </div> */}
                </div>
                {loading ? (
                    <ScaleLoader color="#36d7b7" className="mx-auto" />
                ) : (
                    <button
                        type="submit"
                        className="w-fit py-1 px-4 rounded-md cursor-pointer bg-white hover:scale-105 text-black text-sm mx-auto"
                    >
                        Save
                    </button>
                )}
            </form>
        </div>
    )
}